export const getUserFromLocalStorage = () => {
  try {
    const user = localStorage.getItem("user")
    return user ? JSON.parse(user) : null
  } catch (error) {
    localStorage.removeItem("user")
    return null
  }
}
